export default __webpack_public_path__ + "static/LocalFoodProcurementPolicyPreference-b4062cb86d5405d6d41d8299ccfa1197.jpg";